import React, { FC } from 'react';

import { useTranslation } from 'app/lang';
import PromocodeForm from 'app/widgets/PromocodeForm';

import dictionary from './RegistrationModal.dictionary.json';

import styles from '../../Signing.module.scss';

const RegistrationCompleted: FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <p className={styles.regCompleted}>
        {t(dictionary.text)}
      </p>

      <PromocodeForm />
    </>
  );
};

export default RegistrationCompleted;
